import React from 'react';
import { X } from 'lucide-react';

const TermsOfServiceModal = ({ termsOfServiceModalOpen, setTermsOfServiceModalOpen }) => { 
  return (
    <>
      {termsOfServiceModalOpen && (
        <div 
            className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setTermsOfServiceModalOpen(false)}
        >
            <div 
            className="bg-white dark:bg-gray-900 rounded-xl max-w-full w-full sm:max-w-3xl lg:max-w-4xl p-6 shadow-2xl overflow-hidden max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-gray-700"
            onClick={e => e.stopPropagation()}
            >
            <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                <h3 className="text-2xl font-bold dark:text-white flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    Terms of Service Agreement
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Effective Date: {new Date().toLocaleDateString()} | Version 2.1
                </p>
                </div>
                <button 
                onClick={() => setTermsOfServiceModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
                aria-label="Close terms of service"
                >
                <X size={24} />
                </button>
            </div>
            
            <div className="prose dark:prose-invert max-w-none">
                <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">1. Acceptance of Terms</h4>
                <p className="text-gray-700 dark:text-gray-300">
                    By accessing or using the 0x10LayerFF platform ("Service"), you agree to be bound by these Terms of Service ("Terms"). 
                    If you disagree with any part of these Terms, you may not access the Service. These Terms constitute a legally binding 
                    agreement between you and 0x10LayerFF.
                </p>
                </div>

                <div className="grid gap-8">
                <div className="border-l-4 border-blue-500 dark:border-blue-400 pl-4">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">2. License & Intellectual Property</h4>
                    <p className="text-gray-700 dark:text-gray-300 mb-3">
                    Subject to compliance with these Terms, we grant you a limited, non-exclusive, non-transferable license to use our Service. 
                    All content, features, and functionality on the Service are owned by 0x10LayerFF and protected by international copyright, 
                    trademark, patent, trade secret, and other intellectual property laws.
                    </p>
                    <ul className="list-disc pl-5 space-y-2 text-gray-700 dark:text-gray-300">
                    <li>You may not modify, reproduce, distribute, or create derivative works without explicit written permission</li>
                    <li>All trademarks, service marks, and logos are proprietary to 0x10LayerFF</li>
                    <li>User-generated content remains your property but grants us a worldwide license to use, display, and distribute</li>
                    </ul>
                </div>

                <div className="border-l-4 border-blue-500 dark:border-blue-400 pl-4">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">3. User Responsibilities</h4>
                    <p className="text-gray-700 dark:text-gray-300 mb-3">
                    As a condition of use, you agree not to use the Service for any purpose that is unlawful or prohibited by these Terms.
                    </p>
                    <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                        <h5 className="font-medium text-gray-900 dark:text-white mb-2 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                        Prohibited Conduct
                        </h5>
                        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700 dark:text-gray-300">
                        <li>Reverse engineering or decompiling the Service</li>
                        <li>Introducing malware or harmful code</li>
                        <li>Bypassing security measures</li>
                        <li>Data scraping or automated extraction</li>
                        </ul>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg">
                        <h5 className="font-medium text-gray-900 dark:text-white mb-2 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        Compliance Requirements
                        </h5>
                        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700 dark:text-gray-300">
                        <li>Maintain accurate account information</li>
                        <li>Promptly report security issues</li>
                        <li>Comply with all applicable laws</li>
                        <li>Obtain necessary permissions for data processing</li>
                        </ul>
                    </div>
                    </div>
                </div>

                <div className="border-l-4 border-blue-500 dark:border-blue-400 pl-4">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">4. Liability & Disclaimers</h4>
                    <div className="space-y-4 text-gray-700 dark:text-gray-300">
                    <p>
                        <strong>Service Availability:</strong> We strive for 99.9% uptime but do not guarantee uninterrupted service. Scheduled maintenance will be communicated in advance.
                    </p>
                    <p>
                        <strong>Limitation of Liability:</strong> To the maximum extent permitted by law, 0x10LayerFF shall not be liable for any indirect, incidental, special, consequential, or punitive damages.
                    </p>
                    <p>
                        <strong>Warranty Disclaimer:</strong> The Service is provided "as is" without warranty of any kind. We disclaim all warranties, whether express or implied.
                    </p>
                    </div>
                </div>

                <div className="border-l-4 border-blue-500 dark:border-blue-400 pl-4">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">5. Governing Law & Disputes</h4>
                    <p className="text-gray-700 dark:text-gray-300">
                    These Terms shall be governed by the laws of [Jurisdiction] without regard to conflict of law provisions. Any disputes shall be resolved through binding arbitration in [City], administered by [Arbitration Organization] under its Commercial Arbitration Rules.
                    </p>
                </div>

                <div className="border-l-4 border-blue-500 dark:border-blue-400 pl-4">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">6. Modifications</h4>
                    <p className="text-gray-700 dark:text-gray-300">
                    We reserve the right to modify these Terms at any time. Material changes will be communicated via email 30 days prior to taking effect. Continued use after changes constitutes acceptance.
                    </p>
                </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Contact Information</h4>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                    <h5 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Legal Inquiries</h5>
                    <p className="text-sm">legal@0x10layerff.com</p>
                    </div>
                    <div>
                    <h5 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Mailing Address</h5>
                    <p className="text-sm">0x10LayerFF Inc.<br/>123 Security Way<br/>San Francisco, CA 94107</p>
                    </div>
                </div>
                </div>

                <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                <div className="text-sm text-gray-500 dark:text-gray-400">
                    Last updated: {new Date().toLocaleDateString()}
                </div>
                <div className="flex gap-3">
                    <button 
                    onClick={() => window.print()}
                    className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-sm font-medium"
                    >
                    Print Terms
                    </button>
                    <button 
                    onClick={() => setTermsOfServiceModalOpen(false)}
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium"
                    >
                    I Agree to These Terms
                    </button>
                </div>
                </div>
            </div>
            </div>
        </div>
        )}
    </>
  );
};

export default TermsOfServiceModal;